import { useEffect } from 'react'
import { addToast } from '@heroui/react'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import posthog from 'posthog-js'
import { RefundMethodsPage } from '../refund-methods/refund-methods.page'
import RefundMethodPage from './RefundMethod.page'
import { useAppSelector } from '@/redux/hooks'
import { usePages } from '@/hooks'

export const RefundMethodsPageEntry = () => {
    const { t } = useTranslation()

    const navigate = useNavigate()
    const { pages } = usePages()

    const settings = useAppSelector(
        (store) => store.settingsApi.settings.response
    )

    const refundMethodsResponse = useAppSelector(
        (store) => store.refundMethodsApi.refundMethods.response
    )

    const isKeepYourItemOffered =
        refundMethodsResponse.result?.refund_methods?.some(
            (method) => method.keep_your_item?.enabled === true
        )

    const isMisako = settings.ecommerce_group == 'misako'
    const isHoff = settings.ecommerce_group == 'hoff'

    useEffect(() => {
        if (!refundMethodsResponse.result_raw) {
            addToast({
                description: t('toast_errors.lost_order')
            })
            navigate(pages.Landing)
        }
    }, [refundMethodsResponse.result_raw, t, pages.Landing, navigate])

    if (!refundMethodsResponse.result_raw) {
        return null
    }

    return posthog.getFeatureFlag('rdv-gift-cards-layout') === 'test' &&
        !isMisako &&
        !isHoff &&
        !isKeepYourItemOffered ? (
        <RefundMethodsPage />
    ) : (
        <RefundMethodPage />
    )
}
